// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const UserCircle: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 28 29"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M14 .5C6.267.5 0 6.767 0 14.5s6.267 14 14 14 14-6.267 14-14-6.267-14-14-14zm0 26.25c-2.583 0-4.979-.808-6.956-2.179.224-2.694 2.46-4.821 5.206-4.821h3.5c2.748 0 4.984 2.13 5.207 4.821A12.193 12.193 0 0114 26.75zm8.515-3.462c-.771-3.03-3.5-5.288-6.765-5.288h-3.5c-3.266 0-5.994 2.259-6.765 5.29-2.298-2.277-3.735-5.345-3.735-8.79C1.75 7.746 7.246 2.25 14 2.25S26.25 7.746 26.25 14.5c0 3.445-1.438 6.513-3.735 8.788zM14 7.5a4.374 4.374 0 00-4.375 4.375A4.374 4.374 0 1014 7.5zm0 7a2.626 2.626 0 11.001-5.251A2.626 2.626 0 0114 14.5z" />
        </svg>
    );
};

export default React.memo(UserCircle);
